import { useState } from 'react';

import { PredefinedDateRangePreset, getPredefinedDateRange } from './predefined-date-range.utils';

export interface PredefinedDateRangeViewProps {
    predefined: PredefinedDateRangePreset | null;
    selectPreset: (preset: PredefinedDateRangePreset, enabled: boolean) => { start: string; end: string } | null;
}

export const usePredefinedDateRange = (): PredefinedDateRangeViewProps => {
    const [predefined, setPredefined] = useState<PredefinedDateRangePreset | null>(null);

    const selectPreset = (preset: PredefinedDateRangePreset, enabled: boolean) => {
        setPredefined(enabled ? preset : null);
        if (!enabled) {
            return null;
        }
        return getPredefinedDateRange(preset);
    };

    return {
        predefined,
        selectPreset
    };
};
